<template>
	<v-container theme="light">
		<v-row class="contentRow">
			<v-col>
				<h1>Dashboard</h1>
			</v-col>
			<p style="margin: 30px 50px;">
							This dashboard provides an integrated view of your sustainability
							performance and that of your connections across key areas: Human Rights,
							Labour, Environment, and Anti-Corruption which aligns with the UNGC
							principles for sustainable business practices. Additionally, represents
							your company's timely risk matrix, an overview of risk definitions
							you've given, and action plans you have created, enabling comprehensive
							risk management. <br />
			</p>

			<v-container theme="light" style="background-color: #ffffff">
				<div class="dashboardriskdisplay">
					<v-col cols="5.5" xl="4" lg="6" md="8" sm="8" xs="12" class="riskpointdashboard">
						<v-col class="createriskdashboard" style="margin-top: -80px;">
							<v-autocomplete
								:items="items"
								v-model="selectedItem"
								item-text="Title"
								item-value="Title"
								label="Select a Matrix"
								dense
								outlined
								clearable
								style="position: relative; top: 110px; margin-right: 200px; padding-left: 100px;"
								@change="logSelectedItemId"
								:filter="customFilter"
								>
								<template v-slot:item="data">
									<div>
										{{ data.item.Title }}
										<div style="font-size: 12px; color: gray; margin-bottom: 5px;">
											Owner: {{ data.item.Owner || "—" }}
										</div>
									</div>
								</template>
							</v-autocomplete>

							<div
								class="risk-chart-wrapper"
								style="margin-left: 30px; margin-top: 30px;"
							>
								<v-col style="margin-bottom: -65px;">
									<DashboardRiskmatrixChart :offsetValue="-0.5" />
									<div class="horizontal-text">Probability</div>
								</v-col>
							</div>
						</v-col>
					</v-col>

					<v-col cols="6" xl="4" lg="6" md="8" sm="8" xs="12" class="commentsection ml-5">
						<div class="commentBoxOuter">
							<div class="commentBox">
								<div class="commentTopRow">
									<div class="commentFieldInline">
										<label>Date:</label>
										<span v-if="!isEditing">{{ commentDate || "—" }}</span>
										<input
											v-else
											type="date"
											v-model="commentDate"
											class="commentInputInline"
											style="outline: none;"
										/>
									</div>
									<div class="commentFieldInline">
										<label>Risk Matrix Owner:</label>
										<span v-if="!isEditing">{{ commentManager || "—" }}</span>
										<input
											v-else
											type="text"
											v-model="commentManager"
											class="commentInputInline"
											placeholder="Matrix Owner"
											style="outline: none;"
										/>
									</div>
								</div>

								<div class="commentReview">
									<label>Risk assessment review:</label>
									<p v-if="!isEditing" class="commentViewText">{{ comment || "No comments yet." }}</p>
									<template v-else>
										<textarea
											class="commentclass"
											v-model="comment"
											rows="3"
											maxlength="500"
											placeholder="Overall notes on this risk assessment..."
											style="outline: none;"
										></textarea>
										<div class="commentCharCount" :class="{ 'charCountWarn': remainingChars <= 50 }">
											{{ comment ? comment.length : 0 }}/500
										</div>
									</template>
								</div>

								<div class="commentButtons">
									<v-btn v-if="isEditing" color="success" class="mr-3" @click="saveComments">
										Save
									</v-btn>
									<v-btn v-else color="primary" @click="editComments">
										Edit
									</v-btn>
								</div>
							</div>
						</div>
					</v-col>
				</div>
			</v-container>
			
			<div class="riskdescription">
				<RiskmatrixwithtableVue />
			</div>

			<div class="riskdescription mt-10">
				<ActionPlanRisk :title="this.title" />
			</div>
			<div class="riskdescription mt-10 pa-10 grey lighten-5">
				<h3 class="categoryDescTitle">Category Descriptions</h3>
				<div class="categoryDescContainer">
					<div
						v-for="category in riskCategories"
						:key="category.id"
						class="categoryGroup"
					>
						<h4 class="categoryGroupTitle">{{ category.title }}</h4>
						<div class="subcategoryGrid">
							<div
								v-for="sub in category.subcategories"
								:key="sub.name"
								class="subcategoryItem"
							>
								<span class="subcategoryName">{{ sub.name }}:</span>
								<span class="subcategoryDesc">{{ sub.description }}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="dashdivcontainer">
				<div class="savebutton">
					<v-btn color="primary" @click="saveAsPdf">
						<h2>Save as PDF</h2>
					</v-btn>
				</div>
			</div>
		</v-row>
	</v-container>
</template>

<script>
import ActionPlanRisk from "../components/PDF/ActionPlanRisk.vue"
import RiskmatrixwithtableVue from "../components/PDF/Riskmatrixwithtable.vue"
import DashboardRiskmatrixChart from "../components/DashboardRiskmatrixChart.vue"
import { riskmatrixAPI } from "../api/csr/riskmatrix"

export default {
	components: {
		ActionPlanRisk,
		RiskmatrixwithtableVue,
		DashboardRiskmatrixChart,
	},
	data() {
		return {
			comment: "",
			title: "",
			matrixId: "",
			commentDate: "",
			commentManager: "",
			items: [],
			selectedItem: null,
			matrixes: [],
			isEditing: false,    
			currentMatrix: null,
			riskCategories: [
				{
					id: 1,
					title: "Governance & Management",
					subcategories: [
						{
							name: "Corruption",
							description: "Risks related to bribery, fraud, unethical conduct, and lack of anti-corruption controls. This includes exposure from facilitation payments, conflicts of interest, and weak whistleblower protections. Poor controls in this area can lead to legal penalties, reputational damage, and loss of stakeholder trust.",
						},
						{
							name: "Country",
							description: "Risks arising from the political, legal, or economic environment of the country of operation. These can include regulatory instability, currency fluctuations, trade restrictions, or geopolitical conflict. Operating in high-risk jurisdictions may also increase exposure to corruption, sanctions, and human rights concerns.",
						},
						{
							name: "Financial",
							description: "Risks related to financial stability, reporting accuracy, budgeting, and fiscal controls. This covers liquidity constraints, misstatement of financial results, and inadequate internal audit processes. Weaknesses here can undermine investor confidence and an organization's ability to meet its obligations.",
						},
						{
							name: "Quality Assurance Management",
							description: "Risks related to processes ensuring products/services consistently meet quality standards. This includes gaps in testing, inspection, and certification procedures across the value chain. Failures can result in defective outputs, regulatory non-compliance, and damage to customer trust.",
						},
						{
							name: "Management",
							description: "Risks related to organizational leadership, decision-making structures, and internal oversight. This includes unclear accountability, insufficient governance frameworks, and poor succession planning. Weak management practices can slow response to emerging risks and reduce overall organizational resilience.",
						},
					],
				},
				{
					id: 2,
					title: "People & Human Rights",
					subcategories: [
						{
							name: "Gender Rights",
							description: "Risks related to gender equality, discrimination, and equal opportunity in the workplace. This includes unequal pay, limited access to leadership roles, and inadequate protections against harassment. Addressing these risks is essential to fostering an inclusive and equitable work environment.",
						},
						{
							name: "Human Rights",
							description: "Risks related to violations of fundamental human rights across operations and supply chains. This includes forced labor, unsafe working conditions, and failure to respect the rights of local communities. Such violations can expose organizations to legal liability and severe reputational harm.",
						},
						{
							name: "Labour",
							description: "Risks related to working conditions, fair wages, working hours, and labour practices. This includes non-compliance with minimum wage laws, excessive overtime, and restrictions on freedom of association. Poor labour practices can lead to workforce disruption and regulatory sanctions.",
						},
					],
				},
				{
					id: 3,
					title: "Environment & Resources",
					subcategories: [
						{
							name: "Environment",
							description: "Risks related to environmental impact, emissions, waste management, and regulatory compliance. This includes pollution incidents, inadequate waste disposal practices, and failure to meet emissions targets. These risks can result in regulatory penalties and long-term ecological harm.",
						},
						{
							name: "Technology",
							description: "Risks related to reliance on outdated systems, cybersecurity, or lack of technological resilience. This includes vulnerability to data breaches, system downtime, and insufficient disaster recovery planning. Failure to modernize can also leave an organization less competitive and less able to adapt.",
						},
						{
							name: "Water Use",
							description: "Risks related to water consumption, scarcity, and responsible water management. This includes over-extraction in water-stressed regions and inadequate wastewater treatment. Poor water stewardship can disrupt operations and affect relationships with local communities.",
						},
					],
				},
				{
					id: 4,
					title: "Operations & Supply Chains",
					subcategories: [
						{
							name: "Market",
							description: "Risks related to market volatility, competition, and demand fluctuations. This includes shifting consumer preferences, price instability, and the entry of disruptive competitors. Failure to anticipate these changes can erode market share and profitability.",
						},
						{
							name: "Production",
							description: "Risks related to manufacturing processes, capacity, and operational continuity. This includes equipment failure, capacity constraints, and disruptions from natural disasters or labor shortages. Production risks can directly affect an organization's ability to meet delivery commitments.",
						},
						{
							name: "Quality",
							description: "Risks related to product or service quality control and consistency. This includes inconsistent output, insufficient quality checks, and non-conformance with industry standards. Recurring quality issues can damage customer trust and increase liability exposure.",
						},
						{
							name: "Supply Chains",
							description: "Risks related to supplier reliability, traceability, and supply chain disruptions. This includes dependency on single-source suppliers, lack of visibility into upstream practices, and vulnerability to logistics failures. Weak supply chain oversight can also increase exposure to ethical and environmental violations further down the chain.",
						},
					],
				},
			],
		}
	},
	computed: {
		remainingChars() {
			return 500 - (this.comment ? this.comment.length : 0)
		},
	},
	methods: {
		editComments() {
			this.isEditing = true
		},

		saveComments() {
			if (!this.currentMatrix) {
				alert("Please select a risk matrix first.")
				return
			}

			riskmatrixAPI
				.updateRiskById(
					this.currentMatrix.ID,
					this.currentMatrix.Title,
					this.commentManager,
					this.currentMatrix.Description,
					this.currentMatrix.Year,
					this.currentMatrix.Status,
					this.comment
				)
				.then(() => {
					this.currentMatrix.Owner = this.commentManager
					this.currentMatrix.Comment = this.comment
					this.isEditing = false  
				})
				.catch((error) => {
					console.error(error)
					alert("Failed to save. Please try again.")
				})
		},
		saveAsPdf() {
			const matrixId = this.$store.getters.selectedId
			if (!matrixId) {
				alert("Please select a risk matrix before saving as PDF.")
				return
			}

			this.$router.push({
				name: "RiskDashboardPDF",
				query: {
					title: this.$store.getters.selectedTitle || "",
					matrixId: String(matrixId),
					commentDate: this.commentDate || "",
					commentManager: this.commentManager || "",
					comment: this.comment || "",
				},
			})
		},
		loadItems() {
			this.$store.dispatch(
				"loading/START_LOADING",
				null,
				{ root: true }
			)
			riskmatrixAPI
				.getAll("Active")
				.then((data) => {
					this.items = data[0]
					this.items.sort((a, b) => new Date(b.Created) - new Date(a.Created))

					if (
						this.items.length > 0 &&
						this.$store.getters.selectedStatus == "Active" &&
						this.$store.getters.selectedId == null
					) {
						this.selectedItem = this.items[0].Title
						this.chooseChart(this.items[0])
					} else if (
						this.items.length > 0 &&
						this.$store.getters.selectedStatus != "Active"
					) {
						this.selectedItem = this.items[0].Title
						this.chooseChart(this.items[0])
					} else {
						this.selectedItem = this.$store.getters.selectedTitle
						const stillSelected = this.items.find(
							(item) => item.ID === this.$store.getters.selectedId
						)
						if (stillSelected) {
							this.chooseChart(stillSelected)
						}
					}
					this.matrixes = this.items.map((item) => item.Title)
					this.$store.dispatch(
						"loading/END_LOADING",
						null,
						{ root: true }
					)
				})
				.catch((error) => {
					this.$store.dispatch(
						"loading/SET_ERROR",
						error,
						{ root: true }
					)
				})
		},
		logSelectedItemId() {
			const selectedMatrix = this.items.find(
				(item) => item.Title === this.selectedItem
			)
			if (selectedMatrix) {
				this.chooseChart(selectedMatrix)
			} else {
				console.log("Selected item not found in the items array")
			}
		},
		chooseChart(item) {
			this.currentMatrix = item
			this.$store.commit("setSelectedId", item.ID)
			this.$store.commit("setSelectedTitle", item.Title)
			this.$store.commit("setSelectedDescription", item.Description)

			this.commentDate = item.Created ? item.Created.substring(0, 10) : ""
			this.commentManager = item.Owner || ""
			this.comment = item.Comment || ""
			this.isEditing = false  
		},
		customFilter(item, queryText) {
			const title = item.Title ? item.Title.toLowerCase() : ""
			const owner = item.Owner ? item.Owner.toLowerCase() : ""
			const query = queryText.toLowerCase()
			return title.includes(query) || owner.includes(query)
		},
	},
	watch: {
		comment() {
			this.persistComments()
			this.title = this.$store.getters.selectedTitle
			this.matrixId = this.$store.getters.selectedTitle
		},
		commentDate() {
			this.persistComments()
		},
		commentManager() {
			this.persistComments()
		},
	},
	mounted() {
		this.title = this.$store.getters.selectedTitle
		this.matrixId = this.$store.getters.selectedId
		this.loadItems()
	},
	activated() {
		this.loadItems()
	},
	created() {
		this.persistComments = () => {
			sessionStorage.setItem("comment", this.comment)
			sessionStorage.setItem("commentDate", this.commentDate)
			sessionStorage.setItem("commentManager", this.commentManager)
		}
	},
}
</script>

<style>
.commentViewText {
	white-space: pre-wrap;
	word-break: break-word;
	overflow-wrap: anywhere;
	color: #333;
	margin: 0;
}
.riskdescription {
	border: 1px solid #ddd;
	border-radius: 8px;
	padding: 16px;
	box-sizing: border-box;
}
.riskdescription {
	width: 100%;
}
.riskdescription .v-container,
.riskdescription .container {
	max-width: 100% !important;
	width: 100% !important;
}
.selfassementcard {
	margin: 10px;
	width: 100%;
}
.savebutton {
	margin-top: 20px;
	margin-bottom: 20px;
	display: flex;
	justify-content: center;
}
.dashdivcontainer {
	width: 100%;
}
.dashboardriskdisplay {
	display: flex;
	align-items: flex-start;  
	margin-bottom: 50px;
}
.riskpointdashboard {
	display: flex;
	height: 550px;
	border: 1px solid #ddd;
	margin-top: 10px;
	border-radius: 10px;
	align-items: center;
	justify-self: center;
}
.commentsection {
	margin: -12px;
	display: flex;
	align-items: flex-start;
}
.createriskdashboard .risk-chart-wrapper {
	transform: scale(0.75);
}
.createriskdashboard .risk-chart-wrapper .divcolumn {
	margin-left: -150px !important;
}
.horizontal-text {
	margin-top: 10px;
	margin-right: -30px;
	margin-bottom: 10px;
	color: #217b7f;
	letter-spacing: 10px;
	font-weight: 1000;
	font-size: 16px;
}
.commentBoxOuter {
	width: 100%;
	max-width: 100%;
	box-sizing: border-box;
}
.commentBox {
	width: 100%;
	max-width: 100%;
	box-sizing: border-box;
	height: auto;
	min-height: 550px;
	display: flex;
	flex-direction: column;
	border: 1px solid #ddd;
	border-radius: 14px;
	padding: 24px 28px;
	background-color: #ffffff;
}
.commentButtons {
	display: flex;
	justify-content: flex-end;
	align-items: center;
	margin-top: auto;
}
.commentTopRow {
	display: flex;
	flex-wrap: wrap;
	gap: 30px;
	margin-bottom: 18px;
}
.commentFieldInline {
	display: flex;
	align-items: center;
	gap: 10px;
}
.commentFieldInline label {
	font-weight: bold;
	white-space: nowrap;
}
.commentInputInline {
	border: 1px solid #ddd;
	border-radius: 4px;
	padding: 4px 8px;
	font-size: 14px;
}
.commentReview {
	margin-bottom: 20px;
	flex: 1;
}
.commentReview label {
	font-weight: bold;
	display: block;
	margin-bottom: 6px;
}
.commentclass {
	width: 100%;
	padding: 12px 16px;
	box-sizing: border-box;
	border: 1px solid #ddd;
	border-radius: 4px;
	background-color: #f8f8f8;
	font-size: 15px;
	resize: none;
}
.commentCategoryRow {
	margin-bottom: 16px;
}
.commentCategoryRow label {
	font-weight: bold;
	color: #1c3f5e;
	display: block;
	margin-bottom: 6px;
}
.commentCharCount {
	font-size: 12px;
	color: #777;
	text-align: right;
	margin-top: 4px;
}
.charCountWarn {
	color: #d9534f;
	font-weight: bold;
}
.categoryDescTitle {
	margin-bottom: 16px;
	color: #1c3f5e;
}
.categoryDescContainer {
	display: flex;
	flex-direction: column;
	gap: 20px;
}
.categoryGroup {
	border: 1px solid #eee;
	border-radius: 8px;
	padding: 12px 16px;
}
.categoryGroupTitle {
	color: #217b7f;
	margin-bottom: 10px;
	font-weight: 700;
}
.subcategoryGrid {
	display: flex;
	flex-direction: column;
}
.subcategoryItem {
	font-size: 14px;
	line-height: 1.5;
	padding: 12px 0;
	border-bottom: 1px solid #eee;
}
.subcategoryItem:last-child {
	border-bottom: none;
}
.subcategoryName {
	font-weight: bold;
	color: #333;
	display: block;
	margin-bottom: 4px;
}
.subcategoryDesc {
	color: #555;
}
@media (min-width: 1900px) {
	.dashboardriskdisplay {
		display: flex;
		margin-bottom: 50px;
		justify-content: center;
		gap: 40px;
	}
}
@media (min-width: 960px) and (max-width: 1263px) {
	.dashboardriskdisplay {
		display: flex;
		flex-direction: column;
		align-items: center;
		margin-bottom: 50px;
		justify-content: center;
		gap: 40px;
	}
	.riskpointdashboard {
		display: flex;
		height: 550px;
		border: 1px solid #ddd;
		margin-top: 10px;
		margin-left: 22px;
		border-radius: 10px;
		align-items: center;
		justify-self: center;
	}
}
@media (max-width: 960px) {
	.dashboardriskdisplay {
		display: flex;
		flex-direction: column;
		align-items: center;
		margin-bottom: 50px;
		justify-content: center;
		gap: 40px;
	}
	.riskpointdashboard {
		display: flex;
		height: 550px;
		border: 1px solid #ddd;
		margin-top: 10px;
		margin-left: 22px;
		border-radius: 10px;
		align-items: center;
		justify-self: center;
	}
	.createriskdashboard .risk-chart-wrapper {
		transform: scale(0.6);
	}
	.createriskdashboard .risk-chart-wrapper .divcolumn {
		margin-left: -150px !important;
	}
}
</style>